// Project.js
import React from 'react';
import { Link } from 'react-router-dom';
import MacWindowControls from './MacWindowControls';
import '../styles/Project.css';

function Project() {
  const projects = [
    {
      id: 'shukkin',
      title: 'シュッキン',
      description: 'シュッキンはチーム活動管理を簡単に行うためのアプリです。このアプリはチームの活動を管理し、ユーザーが簡単にチームの状況を把握できるようにします。',
      imageUrl: 'https://fusessei.s3.ap-northeast-1.amazonaws.com/Shukkin_Promo.png',
      tags: ['iOSアプリ', 'チーム活動'],
    },
  ];

  return (
    <section id="project" className="project-section">
      <div className="project-content">
        <div className="project-intro">
          <h2 className="project-title">Our Projects</h2>
        </div>
        <div className="project-grid">
          {projects.map((project) => (
            <div key={project.id} className="mac-app-scroll">
              {project.id === 'shukkin' ? (
                <Link to="/shukkin" className="project-link">
                  <div className="mac-app-window">
                    <MacWindowControls />
                    <div className="project-card">
                      <div className="project-card-top">
                        <img src={project.imageUrl} alt={project.title} className="project-image" />
                        <div className="project-info">
                          <h3 className="project-name">{project.title}</h3>
                          <div className="project-tags">
                            {project.tags.map((tag, index) => (
                              <div key={index} className="project-tag">{tag}</div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="project-card-bottom">
                        <p className="project-description">{project.description}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              ) : (
                <div className="mac-app-window">
                  <MacWindowControls />
                  <div className="project-card">
                    <div className="project-card-top">
                      <img src={project.imageUrl} alt={project.title} className="project-image" />
                      <div className="project-info">
                        <h3 className="project-name">{project.title}</h3>
                        <div className="project-tags">
                          {project.tags.map((tag, index) => (
                            <div key={index} className="project-tag">{tag}</div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="project-card-bottom">
                      <p className="project-description">{project.description}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Project;
